module.exports = __webpack_public_path__ + "static/media/B37545 Notice of Proposal to Refuse to Renew.e21d3f70.pdf";